export const ANDROID_INSTALL_PREFERENCE_KEY = "tb_android_app_promotion_until_v1";
export const ANDROID_INSTALL_SUPPRESSION_MS = 7 * 24 * 60 * 60 * 1000;

const PLAY_STORE_PACKAGE = "com.todaysbrief.dashboard";
const INSTALL_PLACEMENTS = new Set(["hero", "dock", "platform", "footer"]);
const AUTOMATED_AUDIENCE = /bot\b|crawler|spider|slurp|headless|facebookexternalhit|lighthouse/i;

/** Presentation hint only; do not retain or transmit browser identity. */
export function isAndroidAppAudience({ platform = "", userAgent = "", standalone = false } = {}) {
  if (standalone || AUTOMATED_AUDIENCE.test(userAgent)) return false;
  return /^android$/i.test(platform.trim()) || /\bAndroid\b/i.test(userAgent);
}

/** Reject malformed or overlong preferences so a dismissal always expires. */
export function isAndroidInstallSuppressed(value, now = Date.now()) {
  if (typeof value !== "number" && typeof value !== "string") return false;
  if (typeof value === "string" && !value.trim()) return false;
  const until = Number(value);
  return (
    Number.isFinite(now) &&
    Number.isFinite(until) &&
    until > now &&
    until <= now + ANDROID_INSTALL_SUPPRESSION_MS
  );
}

/** Returning web users keep their existing direct route into the product. */
export function androidEntryDestination({ signedIn, completed, androidAudience, suppressed }) {
  if (signedIn || completed) return "/app/brief";
  return androidAudience && !suppressed ? "android-landing" : "/onboarding";
}

/** Fixed campaign facts only: never forward an incoming query or visitor identifier. */
export function playStoreInstallUrl(placement) {
  const referrer = new URLSearchParams({
    utm_source: "todaysbrief_web",
    utm_medium: "website",
    utm_campaign: "android_app",
    utm_content: INSTALL_PLACEMENTS.has(placement) ? placement : "hero",
  });
  const store = new URL("https://play.google.com/store/apps/details");
  store.searchParams.set("id", PLAY_STORE_PACKAGE);
  store.searchParams.set("referrer", referrer.toString());
  return store.toString();
}
